import { fetchTimeInterval, getCurrentDate, getCurrentTime, getLookupByKey, optionsToKeyValuePairs, isSet } from "../../../../../../utils/commonUtils";
import { VACCINATION_NAME, VACCINATION_SPECIFY_REASON } from "../../../../../../utils/constant";
import { computationRules1 } from "./DrugScreenCollection";

export const fetchVaccineName = async (val, props, callback = () => { }) => {
  let optionArr = [];
  try {
    const vaccine_name = await getLookupByKey(VACCINATION_NAME);
    optionArr = vaccine_name;
    callback(optionArr);
  } catch (e) {

  }
  return optionArr;
}

export const fetchVaccineSpecifyReason = async (val, props, callback = () => { }) => {
  let optionArr = [];
  try {
    const reason = await getLookupByKey(VACCINATION_SPECIFY_REASON, false);
    optionArr = reason;
    callback(reason);
  } catch (e) {

  }
  return optionArr;
}

export const NewVaccination = async (props) => {
  // Pre-load vaccine name options
  let vaccineNameOptions = [];
  try {
    vaccineNameOptions = await getLookupByKey(VACCINATION_NAME);
  } catch (e) {
    console.warn('Failed to load vaccine names:', e);
  }

  const stackedFieldStyle = {
    layout: 'stacked',
    showContainerBorder: false,
    labelWrap: false,
    isLabel: true,
  };

  const charts = [
    {
      type: "Grid",
      col: "col-md-3",
      data: [
        {
          type: "PatientDetails",
          employeeDetails: props.employeeDetails,
          visitDetails: props.visitDetails,
        },
        {
          type: "CompanyDetails",
          companyDetails: props.companyDetails,
        },
      ],
    },
    {
      type: "Tab",
      col: "col-md-9",
      data: [
        {
          id: "history1",
          label: "History",
          data: [
            {
              label: "History1",
              labelStyle: "fw-semibold",
              hideHeader: true, // Single header: "History" + Yes/No in NewYesOrNoFields header only
              cardBodyClassName: 'p-0',
              fieldProps: stackedFieldStyle,
              fields: [
                {
                    type: 'NewYesOrNoFields',
                    label: 'History',
                    col: 'col-12',
                    headerColAppendClass:'ml-0 pl-0',
                    options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
                    defaultValues: {
                        // history_sick_today: 0,
                        // history_allergies: 0,
                        // history_vaccination_reaction: 0,
                        // history_long_term_health_problem: 0,
                        // history_immune_system_problem: 0,
                        // history_immune_medications: 0,
                        // history_seizure_nervous_system: 0,
                        // history_blood_transfusion: 0,
                        // history_pregnancy: 0,
                        // history_recent_vaccinations: 0
                    },
                    list: [
                        { label: '1. Are you sick today?', name: 'history_sick_today', id: 'history_sick_today' },
                        { label: '2. Do you have allergies to medications, food, a vaccine component, or latex?', name: 'history_allergies', id: 'history_allergies' },
                        { label: '3. Have you ever had a serious reaction after receiving a vaccination?', name: 'history_vaccination_reaction', id: 'history_vaccination_reaction' },
                        { label: '4. Do you have a long-term health problem with heart, lung, kidney, or metabolic disease (e.g., diabetes), asthma, a blood disorder, no spleen, complement component deficiency, a cochlear implant, or a spinal fluid leak? Are you on long-term aspirin therapy?', name: 'history_long_term_health_problem', id: 'history_long_term_health_problem' },
                        { label: '5. Do you have cancer, leukaemia, HIV/AIDS, or any other immune system problem?', name: 'history_immune_system_problem', id: 'history_immune_system_problem' },
                        { label: '6. In the past 3 months, have you taken medications that affect your immune system, such as prednisone, other steroids, or anticancer drugs; drugs for the treatment of rheumatoid arthritis, Crohn\'s disease, or psoriasis; or have you had radiation treatments?', name: 'history_immune_medications', id: 'history_immune_medications' },
                        { label: '7. Have you had a seizure or a brain or other nervous system problem?', name: 'history_seizure_nervous_system', id: 'history_seizure_nervous_system' },
                        { label: '8. During the past year, have you received a transfusion of blood or blood products, or been given immune (gamma) globulin or an antiviral drug?', name: 'history_blood_transfusion', id: 'history_blood_transfusion' },
                        { label: '9. For women: Are you pregnant or is there a chance you could become pregnant during the next month?', name: 'history_pregnancy', id: 'history_pregnancy' },
                        { label: '10. Have you received any vaccinations in the past 4 weeks?', name: 'history_recent_vaccinations', id: 'history_recent_vaccinations' }
                    ]
                }
            ]
            },
            {
              label: "Patient Signature & Comments",
              labelStyle: "fw-semibold",
              fields: [
                {
                  label: "Comments",
                  type: "TextArea",
                  name: "patient_comments",
                  placeholder: "Content",
                  layout: 'stacked',
                  className: "form-control form-control-solid",
                  col: 'col-md-6 col-12 border-0',
                  labelStyle: { paddingLeft: '0.75rem' },
                  style: { minHeight: '150px', resize: 'vertical' },
                  rows: 5,
                },
                {
                  label: "Signature",
                  type: "NewSignature",
                  name: "patient_signature",
                  layout: 'stacked',
                  col: 'col-6 border-0',
                  isLabel: false,
                },
              ],
            },
          ],
        },
        {
          id: "vaccine_admin",
          label: "Vaccine Admin",
          data: [
            {
              label: `Vaccine Document`,
              labelStyle: "fw-semibold",
              fields: [
                {
                  type: "SelectSearchList",
                  label: "Vaccine Name",
                  placeholder: "",
                  className: "form-control form-control-solid",
                  name: "vaccine_name",
                  required: true,
                  options: vaccineNameOptions,
                  layout: 'stacked',
                  col: 'col-6 border-0',
                },
                {
                  label: "Visit Date",
                  required: true,
                  placeholder: "",
                  className: "form-control form-control-solid",
                  type: 'Date',
                  name: "visit_date",
                  layout: 'stacked',
                  col: 'col-6 border-0',
                },
                {
                  type: "SelectSearchList",
                  label: "Visit Time",
                  placeholder: "Time",
                  isAsync: true,
                  options: [{ 'label': getCurrentTime(), value: getCurrentTime() }],
                  loadCallBack: (val, callback) => fetchTimeInterval(val, callback),
                  className: "form-control form-control-solid",
                  name: "visit_time",
                  layout: 'stacked',
                  col: 'col-6 border-0',
                },
                {
                  type: "RadioGroup",
                  options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
                  formGroup: "form-group form-check form-check-solid",
                  className: "form-check-input",
                  label: "Patient declines vaccination",
                  required: true,
                  placeholder: "",
                  name: "patient_declines_vaccination",
                  layout: 'stacked',
                  col: 'col-6 border-0 ',
                },
                {
                  type: "TextInput",
                  label: "Lot Number",
                  placeholder: "",
                  className: "form-control form-control-solid",
                  name: "lot_number",
                  layout: 'stacked',
                  col: 'col-6 border-0',
                  stacked: true,
                },
                // {
                //   type: "NonEdit",
                //   label: "",
                //   placeholder: "",
                //   className: "form-control form-control-solid",
                //   name: "",
                //   layout: 'stacked',
                //   col: 'col-12 border-0',
                //   rules: [{ rule: [{ field: 'patient_declines_vaccination', value: 1, operator: '!==' }], action: 'SHOW' }],
                // },
                // {
                //   type: "SelectSearchList",
                //   label: "Specify reason",
                //   options: [],
                //   isAsync: true,
                //   placeholder: "",
                //   isMulti: true,
                //   className: "form-control form-control-solid",
                //   name: "specify_reason",
                //   rules: [{ rule: [{ field: 'patient_declines_vaccination', value: 1, operator: '===' }], action: 'SHOW' }],
                //   loadCallBack: (val, callback) => fetchVaccineSpecifyReason(val, props, callback),
                //   layout: 'stacked',
                //   col: 'col-12 border-0',
                // },
              
                {
                  type: "SelectList",
                  label: "Vaccine Administration Site",
                  placeholder: "",
                  className: "form-control form-control-solid",
                  options: [{ label: "--Select--", value: "" }, { label: "Left Deltoid", value: "Left Deltoid" }, { label: "Right Deltoid", value: "Right Deltoid" }],
                  name: "vaccination_adminstration_site",
                  layout: 'stacked',
                  col: 'col-6 border-0',
                },
                {
                  type: "Date",
                  label: "Vaccine Expiration Date",
                  placeholder: "",
                  className: "form-control form-control-solid",
                  name: "vaccine_expiration_date",
                  layout: 'stacked',
                  col: 'col-6 border-0',
                },
                {
                  type: "TextInput",
                  label: "Title",
                  placeholder: "",
                  className: "form-control form-control-solid",
                  name: "title",
                  layout: 'stacked',
                  col: 'col-6 border-0',
                },
                // {
                //   type: "SelectList",
                //   options: [{ label: "--Select--", value: "" }, { label: "1", value: "1" }, { label: "2", value: "2" }],
                //   label: "Vaccine Series",
                //   placeholder: "",
                //   className: "form-control form-control-solid",
                //   name: "series",
                //   layout: 'stacked',
                //   col: 'col-6 border-0',
                // },
                {
                  type: "TextArea",
                  label: "Notes",
                  placeholder: "",
                  className: "form-control form-control-solid",
                  name: "notes",
                  layout: 'stacked',
                  col: 'col-6 border-0',
                },
                {
                  type: "TextInput",
                  label: "Patient ID (optional)",
                  placeholder: "Patient ID",
                  className: "form-control form-control-solid",
                  name: "patient_history_id",
                  layout: 'stacked',
                  col: 'col-6 border-0',
                },
              ],
            },
            {
              label: "Review / Completion",
              labelStyle: "fw-semibold",
              fields: [
                {
                  type: "ProviderSignOff",
                  col: "col-12",
                  fields: [
                    { label: "Signature PIN", name: "provider_pin", col: "col-12" },
                    { label: "Signature", type: "NewSignature", name: "provider_signature", col: "col-12" },
                    { label: "Date", type: "Date", name: "signed_date", col: "col-12" },
                    // { label: "Suggested Result", disabled: true, type: "TextInput", placeholder: "Not Started", name: "suggested_status", col: "col-6" },
                    {
                      type: "SelectList",
                      // options: optionsToKeyValuePairs(['Not Started', 'Administrated', 'Not Administered'],false),
                      options: optionsToKeyValuePairs(['Not Started','Pending','Normal','Abnormal','Negative','Positive','Dispensed','Administered','Failed','Passed','Non-Negative','Cancelled','Inconclusive'],false),
                      label: "Final Results",
                      placeholder: "Not Started",
                      col: "col-12",
                      className: "form-control form-control-solid",
                      name: "status",
                      statusBasedColor: true,
                    },
                    {
                      label: "Activity Status",
                      type: "SelectList",
                      name: "activity_status",
                      col: "col-12",
                      statusBasedColor: true,
                      // options: optionsToKeyValuePairs(['Not Started', 'Ordered', 'Ready for Review', 'Completed', 'Cancelled']),
                      options: optionsToKeyValuePairs(['Not Started','Pending','Pending Lab Confirmation','Pending MRO Confirmation','Ready for Review','Completed','Cancelled'],false)
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "Images",
          label: "Images",
          data: []
        }
      ],
    },
  ];

  const defaultValue = {
    visit_date: getCurrentDate(),
    visit_time: getCurrentTime(),
    status: 'Not Started',
    suggested_status: 'Not Started',
    activity_status: 'Not Started',
  };

  const buttons = {
    label: false,
    labreport: false,
    showTopUpdateButton: false,
    showLabTopActions: false,
  };

  const headers = [];

  return {
    charts,
    defaultValue,
    buttons,
    headers,
    computationFunction: (formData, key) => computationRulesForNewVaccination(formData, key),
  };
};

const computationRulesForNewVaccination = (formData, key) => {
  let returnResult = {};
  const currentStatus = isSet(formData.status, "Not Started");
  const currentActivityStatus = isSet(formData.activity_status, "Not Started");
  if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && key) {
    returnResult.status = "Pending";
    returnResult.activity_status = "Pending";
  }
  if(key==='vaccination_adminstration_site' && formData.vaccination_adminstration_site){
    returnResult.status = 'Administered';
  }else if(key==='vaccination_adminstration_site' && !formData.vaccination_adminstration_site){
    returnResult.status = 'Pending';
  }
  if(key === 'status' && formData.status) {
    const status = formData.status;
    // Check if provider has signed (medical_examiner_signature_two exists and is not empty)
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    switch(status) {
        case 'Not Started':
            returnResult.activity_status = 'Not Started';
            break;
        case 'Pending':
            returnResult.activity_status = 'Pending';
            break;
        case 'Normal':
            // If provider signed, set to Completed; otherwise Pending
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Abnormal':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Negative':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Positive':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Dispensed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Administered':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Failed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Passed':
            returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
            break;
        case 'Non-Negative':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        case 'Cancelled':
            returnResult.activity_status = 'Cancelled';
            break;
        case 'Inconclusive':
            returnResult.activity_status = 'Pending Lab Confirmation';
            break;
        default:
            // No change if status doesn't match any case
            break;
    }
  }

  if(key === 'provider_signature' && formData.status) {
    const status = formData.status;
    const providerSigned = formData.provider_signature && 
                          formData.provider_signature !== "" && 
                          formData.provider_signature !== null && 
                          formData.provider_signature !== undefined;
    
    // Completion statuses that should become "Completed" when provider signs
    const completionStatuses = ['Normal', 'Abnormal', 'Negative', 'Positive', 'Dispensed', 'Administered', 'Failed', 'Passed'];
    
    if (completionStatuses.includes(status)) {
      returnResult.activity_status = providerSigned ? 'Completed' : 'Pending';
    }
  }
  return returnResult;
}
// Commented out existing computation rules - using shared computationRules1 from DrugScreenCollection.js
/*
const computationRules = (formData, key) => {
  let returnResult = {};
  if(key==='status' && formData.status==='Not Started' ){
    return {
      status: 'Not Started',
      activity_status: 'Not Started'
    };
  }
  if((key==='status'||key==='provider_signature') && formData.status==='Administrated' && (formData.provider_signature===''||formData.provider_signature===null||formData.provider_signature===undefined) ){
    return {
      activity_status: 'Ready for Review'
    };
  }
  if(key==='status' && formData.status==='Administrated' && (formData.provider_signature!=='' && formData.provider_signature!==null && formData.provider_signature!==undefined) ){
    return {
      activity_status: 'Completed'
    };
  }
  if(key==='status' && formData.status==='Not Administered' && (formData.provider_signature!=='' && formData.provider_signature!==null && formData.provider_signature!==undefined) ){
    return {
      activity_status: 'Cancelled'
    };
  }
  if((key==='status'||key==='provider_signature') && formData.status==='Not Administered' && (formData.provider_signature===''||formData.provider_signature===null||formData.provider_signature===undefined) ){
    return {
      activity_status: 'Ready for Review'
    };
  }

  if(key==='provider_signature' && formData.provider_signature!=='' && formData.provider_signature!==null && formData.provider_signature!==undefined && formData.status==='Administrated' ){
    return {
      activity_status: 'Completed'
    };
  }
  if(key==='provider_signature' && formData.provider_signature!=='' && formData.provider_signature!==null && formData.provider_signature!==undefined && formData.status==='Not Administered' ){
    return {
      activity_status: 'Cancelled'
    };
  }
  if(key==='patient_declines_vaccination' && formData.patient_declines_vaccination===1  && (formData.provider_signature===''||formData.provider_signature===null||formData.provider_signature===undefined)){
    return {
      status: 'Not Administered',
      activity_status: 'Ready for Review'
    };
  }
  if(key==='patient_declines_vaccination' && formData.patient_declines_vaccination===0 && (formData.provider_signature===''||formData.provider_signature===null||formData.provider_signature===undefined) ){
    return {
      status: 'Administrated',
      activity_status: 'Ready for Review'
    };
  }
  if(key==='patient_declines_vaccination' && formData.patient_declines_vaccination===1  && (formData.provider_signature!=='' && formData.provider_signature!==null && formData.provider_signature!==undefined)){
    return {
      status: 'Not Administered',
      activity_status: 'Cancelled'
    };
  }
  if(key==='patient_declines_vaccination' && formData.patient_declines_vaccination===0 && (formData.provider_signature!=='' && formData.provider_signature!==null && formData.provider_signature!==undefined) ){
    return {
      status: 'Administrated',
      activity_status: 'Completed'
    };
  }
  // Avoid feedback loops when status or activity_status themselves are being changed
  if (key === 'status' || key === 'activity_status') {
    return returnResult;
  }
  
  // Check vaccination-related fields
  const vaccinationFields = [
    'vaccine_name',
  ];
  
  return returnResult;
};
*/